// Who is signed in and what they may do in the current workspace (from GET /me). UI hints only; the server enforces.
import { createContext, useContext } from 'react';
export const MeContext = createContext({ can_run: false, can_manage: false, role: 'anon' });
export const useMe = () => useContext(MeContext);
export const MANAGE_HINT = 'Not available in the demo. Create your own project in My workspace to do this.';
